import { render, staticRenderFns } from "./ShareSMS.vue?vue&type=template&id=3121df35&scoped=true&"
import script from "./ShareSMS.vue?vue&type=script&lang=js&"
export * from "./ShareSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121df35",
  null
  
)

export default component.exports